import React, { useState, useEffect } from 'react';
import Input from "../../input/input_v2";
import Select from "../../select/select_v2";
import Button from "../../button/button_v2";
import { store } from "react-notifications-component";
import api from "../../../services/api";
import identifyErrorMenssage from "../../../services/identifyErrorMenssage";

import validadorCpfCnpj from '../../../services/validadorCpfCnpj';
import validadorDeEmail from '../../../services/validadorEmail';
import buscaCep from "../../../services/buscaCep";
import { Form } from "../../../styles/global";

import * as S from "./styles";

const AddProdutor = ({ ...props }) => {
    const { update, next, estado, nome, cpf_cnpj, telefone, celular, cep, logradouro, bairro, numero, complemento, cidade, produtor, email } = props;

    const [estadoId, setEstadoId] = useState(estado || "");
    const [nomeId, setNomeId] = useState(nome);
    const [cpfCnpj, setCpfCnpj] = useState(cpf_cnpj);
    const [telefoneId, setTelefoneId] = useState(telefone);
    const [celularId, setCelularId] = useState(celular);
    const [cepId, setCepId] = useState(cep);
    const [logradouroId, setLogradouroId] = useState(logradouro);
    const [bairroId, setBairroId] = useState(bairro);
    const [numeroId, setNumeroId] = useState(numero);
    const [complementoId, setComplementoId] = useState(complemento);
    const [cidadeId, setCidadeId] = useState(cidade);
    const [disabled, setDisabled] = useState(true);
    const [disabledEstado, setDisabledEstado] = useState(false);
    const [cepFound, setCepFound] = useState(false);
    const [produtorId, setProdutorId] = useState(produtor);
    const [emailProdutor, setEmail] = useState(email);
    const [addModalShow, setAddModalShow] = useState(false);
    const [a, setA] = useState(true);

    const estados = [
        { value: "SP", label: "São Paulo" },
        { value: "RJ", label: "Rio de Janeiro" },
        { value: "SC", label: "Santa Catarina" },
        { value: "AC", label: "Acre" },
        { value: "AL", label: "Alagoas" },
        { value: "AP", label: "Amapa" },
        { value: "AM", label: "Amazonas" },
        { value: "BA", label: "Bahia" },
        { value: "CE", label: "Ceará" },
        { value: "DF", label: "Distrito Federal" },
        { value: "ES", label: "Espirito Santo" },
        { value: "GO", label: "Goiás" },
        { value: "MA", label: "Maranhão" },
        { value: "MT", label: "Mato Grosso" },
        { value: "MS", label: "Mato Grosso do Sul" },
        { value: "MG", label: "Minas Gerais" },
        { value: "PA", label: "Pará" },
        { value: "PB", label: "Paraíba" },
        { value: "PR", label: "Paraná" },
        { value: "PE", label: "Pernambuco" },
        { value: "PI", label: "Piaui" },
        { value: "RN", label: "Rio Grande do Norte" },
        { value: "RS", label: "Rio Grande do Sul" },
        { value: "RO", label: "Rondônia" },
        { value: "RR", label: "Roraima" },
        { value: "SE", label: "Sergipe" },
        { value: "TO", label: "Tocantins" },
        { value: "", label: "" }
    ];

    const [estadoCep, setEstadoCep] = useState('');

    const [isCpfValido, setIsCpfValido] = useState(false);


    const [loading, setLoading] = useState(false);


    const [erroNome, setErroNome] = useState(false);
    const [erroNomeMsg, setErroNomeMsg] = useState('');

    const [erroCpfCnpj, setErroCpfCnpj] = useState(false);
    const [erroCpfCnpjMsg, setErroCpfCnpjMsg] = useState('');

    const [erroTelefone, setErroTelefone] = useState(false);
    const [erroTelefoneMsg, setErroTelefoneMsg] = useState('');

    const [erroCep, setErroCep] = useState(false);
    const [erroCepMsg, setErroCepMsg] = useState('');

    const [erroLogradouro, setErroLogradouro] = useState(false);
    const [erroLogradouroMsg, setErroLogradouroMsg] = useState('');

    const [erroBairro, setErroBairro] = useState(false);
    const [erroBairroMsg, setErroBairroMsg] = useState('');

    const [erroNumero, setErroNumero] = useState(false);
    const [erroNumeroMsg, setErroNumeroMsg] = useState('');

    const [erroCidade, setErroCidade] = useState(false);
    const [erroCidadeMsg, setErroCidadeMsg] = useState('');

    const [erroEstado, setErroEstado] = useState(false);
    const [erroEstadoMsg, setErroEstadoMsg] = useState('');

    const [erroEmail, setErroEmail] = useState(false);
    const [erroEmailMsg, setErroEmailMsg] = useState('');

    const [loadingCep, setLoadingCep] = useState(false);
    const [enderecoManual, setEnderecoManual] = useState(false);
    const [cepNaoEncontrado, setCepNaoEncontrado] = useState(false);

    const emailIsValid = (value) => {
        if (value && !validadorDeEmail(value)) {
            setErroEmail(true);
            setErroEmailMsg('Insira um e-mail válido.');
            return false;
        }
        setErroEmail(false);
        setErroEmailMsg('');
        return true;
    }

    const saveProducer = async e => {

        if (!emailIsValid(emailProdutor)) {
            store.addNotification({
                title: "Erro!",
                message: "Verifique os campos em vermelho",
                type: "danger",
                insert: "top",
                container: "top-right",
                animationIn: ["animated", "fadeIn"],
                animationOut: ["animated", "fadeOut"],
                dismiss: {
                    duration: 4000,
                    onScreen: true
                }
            });
            return;
        }

        setDisabled(false);

        setLoading(true);

        const payload = {
            estado: estadoId,
            nome: nomeId,
            cpf_cnpj: isCpfValido ? cpfCnpj : '',
            telefone: telefoneId,
            celular: celularId,
            cep: cepId,
            logradouro: logradouroId,
            bairro: bairroId,
            numero: numeroId,
            complemento: complementoId,
            cidade: cidadeId,
            email: emailProdutor,
            // Envia a receita por e-mail sempre que o produtor tiver um e-mail válido cadastrado.
            enviar_receita: validadorDeEmail(emailProdutor) ? 1 : 0,
            endereco_manual: enderecoManual,
        };

        try {

            const response = await api.post(`/produtores`, payload);
            setProdutorId(response.data.data.id);
            setAddModalShow(true);
            setA(false);
            setDisabled(true);
            store.addNotification({
                title: "Sucesso!",
                message: `O produtor foi salvo!`,
                type: "success",
                insert: "top",
                container: "top-right",
                animationIn: ["animated", "fadeIn"],
                animationOut: ["animated", "fadeOut"],
                dismiss: {
                    duration: 4000,
                    onScreen: true
                }
            });

            const produtorID = response.data.data.id

            update(estadoId, nomeId, cpfCnpj, telefoneId, celularId, cepId, logradouroId, bairroId, numeroId, complementoId, cidadeId, produtorID, emailProdutor);
            setLoading(false);
            next();

        } catch (err) {
            setLoading(false);

            const backendMessage = err?.response?.data?.message ?? err?.response?.data?.data?.message;

            if (err?.response?.status === 500) {
                store.addNotification({
                    title: "Erro!",
                    message: identifyErrorMenssage(err, backendMessage || "Internal server error"),
                    type: "danger",
                    insert: "top",
                    container: "top-right",
                    animationIn: ["animated", "fadeIn"],
                    animationOut: ["animated", "fadeOut"],
                    dismiss: {
                        duration: 5000,
                        onScreen: true
                    }
                });
                return;
            }

            try {
                // Reset todos os erros
                setErroNome(false);
                setErroCpfCnpj(false);
                setErroTelefone(false);
                setErroCep(false);
                setErroLogradouro(false);
                setErroBairro(false);
                setErroNumero(false);
                setErroCidade(false);
                setErroEstado(false);

                if (err.response?.data?.data?.message && Array.isArray(err.response.data.data.message)) {
                    const errorMessages = err.response.data.data.message;

                    errorMessages.forEach(message => {
                        if (message.includes('nome should not be empty')) {
                            setErroNome(true);
                            setErroNomeMsg('O campo nome não pode estar vazio');
                        } else if (message.includes('cpf_cnpj should not be empty')) {
                            setErroCpfCnpj(true);
                            setErroCpfCnpjMsg('O campo cpf/cnpj não pode estar vazio');
                        } else if (message.includes('telefone should not be empty')) {
                            setErroTelefone(true);
                            setErroTelefoneMsg('O campo telefone não pode estar vazio');
                        } else if (message.includes('cep should not be empty')) {
                            setErroCep(true);
                            setErroCepMsg('O campo CEP não pode estar vazio');
                        } else if (message.includes('logradouro should not be empty')) {
                            setErroLogradouro(true);
                            setErroLogradouroMsg('O campo logradouro não pode estar vazio');
                        } else if (message.includes('bairro should not be empty')) {
                            setErroBairro(true);
                            setErroBairroMsg('O campo bairro não pode estarvazio');
                        } else if (message.includes('numero should not be empty')) {
                            setErroNumero(true);
                            setErroNumeroMsg('O campo numero não pode estar vazio');
                        } else if (message.includes('cidade should not be empty')) {
                            setErroCidade(true);
                            setErroCidadeMsg('O campo cidade não pode estar vazio');
                        } else if (message.includes('estado should not be empty')) {
                            setErroEstado(true);
                            setErroEstadoMsg('O campo estado não pode estar vazio');
                        }
                    });
                }

                else if (err.response?.data?.message && Array.isArray(err.response.data.message)) {
                    const errorMessages = err.response.data.message;

                    errorMessages.forEach(message => {
                        if (message.includes('nome should not be empty')) {
                            setErroNome(true);
                            setErroNomeMsg('O campo nome não pode estar vazio');
                        } else if (message.includes('cpf_cnpj should not be empty')) {
                            setErroCpfCnpj(true);
                            setErroCpfCnpjMsg('O campo cpf/cnpj não pode estar vazio');
                        } else if (message.includes('telefone should not be empty')) {
                            setErroTelefone(true);
                            setErroTelefoneMsg('O campo telefone não pode estar vazio');
                        } else if (message.includes('cep should not be empty')) {
                            setErroCep(true);
                            setErroCepMsg('O campo cep não pode estar vazio');
                        } else if (message.includes('logradouro should not be empty')) {
                            setErroLogradouro(true);
                            setErroLogradouroMsg('O campo logradouro não pode estar vazio');
                        } else if (message.includes('bairro should not be empty')) {
                            setErroBairro(true);
                            setErroBairroMsg('O campo bairro não pode estar vazio');
                        } else if (message.includes('numero should not be empty')) {
                            setErroNumero(true);
                            setErroNumeroMsg('O campo numero não pode estar vazio');
                        } else if (message.includes('cidade should not be empty')) {
                            setErroCidade(true);
                            setErroCidadeMsg('O campo cidade não pode estar vazio');
                        } else if (message.includes('estado should not be empty')) {
                            setErroEstado(true);
                            setErroEstadoMsg('O campo estado não pode estar vazio');
                        }
                    });
                }
                // Fallback para o formato antigo
                else if (err.response?.data?.errors) {
                    const errors = err.response.data.errors;

                    for (let field in errors) {
                        if (field === 'nome') {
                            setErroNome(true);
                            setErroNomeMsg('O campo não pode estar vazio');
                        } else if (field === 'cpf_cnpj') {
                            setErroCpfCnpj(true);
                            if (cpfCnpj === '') {
                                setErroCpfCnpjMsg('O campo não pode estar vazio');
                            } else {
                                setErroCpfCnpjMsg('Informe um CPF/CNPJ válido!');
                            }
                        } else if (field === 'telefone') {
                            setErroTelefone(true);
                            setErroTelefoneMsg('O campo não pode estar vazio');
                        } else if (field === 'cep') {
                            setErroCep(true);
                            setErroCepMsg('O campo não pode estar vazio');
                        } else if (field === 'logradouro') {
                            setErroLogradouro(true);
                            setErroLogradouroMsg('O campo não pode estar vazio');
                        } else if (field === 'bairro') {
                            setErroBairro(true);
                            setErroBairroMsg('O campo não pode estar vazio');
                        } else if (field === 'numero') {
                            setErroNumero(true);
                            setErroNumeroMsg('O campo não pode estar vazio');
                        } else if (field === 'cidade') {
                            setErroCidade(true);
                            setErroCidadeMsg('O campo não pode estar vazio');
                        } else if (field === 'estado') {
                            setErroEstado(true);
                            setErroEstadoMsg('O campo não pode estar vazio');
                        }
                    }
                }
                else {
                }

                store.addNotification({
                    title: "Erro!",
                    message: "Verifique os campos em vermelho",
                    type: "danger",
                    insert: "top",
                    container: "top-right",
                    animationIn: ["animated", "fadeIn"],
                    animationOut: ["animated", "fadeOut"],
                    dismiss: {
                        duration: 4000,
                        onScreen: true
                    }
                });
            } catch (innerErr) {
                console.error('Erro ao processar validação:', innerErr);
                store.addNotification({
                    title: "Erro!",
                    message: identifyErrorMenssage(innerErr, "ERRO-594 Erro interno do sistema - Tente novamente, se o erro persistir acione o suporte."),
                    type: "danger",
                    insert: "top",
                    container: "top-right",
                    animationIn: ["animated", "fadeIn"],
                    animationOut: ["animated", "fadeOut"],
                    dismiss: {
                        duration: 4000,
                        onScreen: true
                    }
                });
            }
        }
    }


    const fetchCep = async () => {
        try {

            setLoadingCep(true);
            setCepNaoEncontrado(false);
            setEnderecoManual(false);

            const cep = await buscaCep(cepId);

            const { logradouro, bairro, localidade, uf } = cep;

            setLogradouroId(logradouro);
            setBairroId(bairro);
            setCidadeId(localidade);
            setEstadoId(uf);
            setEstadoCep(uf);
            setCepFound(true);

            setErroCep(false);
            setErroLogradouro(false);
            setErroBairro(false);
            setErroNumero(false);
            setErroCidade(false);
            setErroEstado(false);
            setLoadingCep(false);

        } catch (err) {

            setCepFound(false);
            setLoadingCep(false);
            setErroCep(err.type === "invalid");
            setErroCepMsg(err.type === "invalid" ? err.message : "");

            if (err.type === "not_found" || err.type === "provider_error") {
                setEnderecoManual(true);
                setLogradouroId("");
                setBairroId("");
                setCidadeId("");

                store.addNotification({
                    title: "Atenção!",
                    message: identifyErrorMenssage(err, "ERRO-595 CEP não encontrado. Preencha o endereço manualmente ou tente novamente - Tente novamente, se o erro persistir acione o suporte."),
                    type: "warning",
                    insert: "top",
                    container: "top-right",
                    animationIn: ["animated", "fadeIn"],
                    animationOut: ["animated", "fadeOut"],
                    dismiss: {
                        duration: 5000,
                        onScreen: true
                    }
                });
            }
        }
    };

    const cpfIsValid = async (value) => {
        if (!value) {
            setIsCpfValido(false);
            setErroCpfCnpj(false);
            return;
        }

        const resultado = await validadorCpfCnpj(value);

        setIsCpfValido(resultado.valido);
        setErroCpfCnpj(!resultado.valido);
        setErroCpfCnpjMsg(resultado.erro || 'Informe um CPF/CNPJ válido');

        if (!resultado.valido) {
            store.addNotification({
                title: "Erro!",
                message: resultado.erro || "Informe um CPF/CNPJ válido.",
                type: "danger",
                insert: "top",
                container: "top-right",
                animationIn: ["animated", "fadeIn"],
                animationOut: ["animated", "fadeOut"],
                dismiss: {
                    duration: 4000,
                    onScreen: true
                }
            });
        }

    }

    const validateNome = nomeId => {
        setNomeId(nomeId);
        setErroNome(false);

    }
    const validateCpf = (cpfCnpj) => {
        setCpfCnpj(cpfCnpj);
        setErroCpfCnpj(false);

    }
    const validateTelefone = telefoneId => {
        setTelefoneId(telefoneId);
        setErroTelefone(false);

    }
    const validateCelular = celularId => {
        setCelularId(celularId);
    }
    const validateCep = cepId => {
        setCepId(cepId);
        setErroCep(false);
        setCepFound(false);
    }
    const validateLogradouro = logradouroId => {
        setLogradouroId(logradouroId);
        setErroLogradouro(false);

    }
    const validateBairro = bairroId => {
        setBairroId(bairroId);
        setErroBairro(false);

    }
    const validateNumero = numeroId => {
        setNumeroId(numeroId);
        setErroNumero(false);

    }
    const validateComplemento = complementoId => {
        setComplementoId(complementoId);
    }
    const validateCidade = cidadeId => {
        setCidadeId(cidadeId);
        setErroCidade(false);

    }
    const validateproduto = produtorId => {
        setProdutorId(produtorId);
    }

    const validateEstado = uf => {
        if (estadoId != uf) {
            setEstadoId(uf);
        }
    }

    useEffect(() => {

        if (props.isModal != true) {
            window.scrollTo(0, 0);
        }
    }, []);

    useEffect(() => { validateproduto(produtorId) }, [produtorId])



    useEffect(() => {
        if (estadoId && cidadeId && !enderecoManual) {
            setDisabledEstado(true);
        } else {
            setDisabledEstado(false);
        }

        if (erroEstado === true && estadoId) {
            setErroEstado(false);
        }
    }, [estadoId, cidadeId, enderecoManual])

    useEffect(() => {
        if (props.crm === true) {
            setNomeId(props.nomeProdutorCrm);
            setEmail(props.emailProdutorCrm);
            setTelefoneId(props.telefoneProdutorCrm);
            setCelularId(props.celularProdutorCrm);
        }
    }, [props])


    return (<>
        <Form
            step={1}
            isModal={props.isModal}
            isFocus={props.isFocus}
        >
            <Input
                marginBottom="4px"
                label="Nome"
                name="nome"
                className="input"
                id="nome"
                onChange={e => validateNome(e)}
                maxlength={50}
                erro={erroNome}
                messageErro={erroNomeMsg}
                value={nomeId}
                labelWithAsterisk
            />

        <S.ContainerInput>
            <Input
                marginBottom="4px"
                label="E-mail"
                name="email"
                className="input"
                id="email"
                onChange={e => {
                    setEmail(e);
                    if (erroEmail) {
                        setErroEmail(false);
                        setErroEmailMsg('');
                    }
                }}
                onBlur={() => emailIsValid(emailProdutor)}
                erro={erroEmail}
                messageErro={erroEmailMsg}
                value={emailProdutor}
            />
        </S.ContainerInput>

            <Input
                marginBottom="4px"
                label="CPF/CNPJ"
                name="cpfcnpj"
                className="input"
                id="cpf_cnpj"
                value={cpfCnpj}
                onChange={e => validateCpf(e)}
                onBlur={(e) => cpfIsValid(e.target.value)}
                maxLength={18}
                erro={erroCpfCnpj}
                messageErro={erroCpfCnpjMsg}
                inputmode="numeric"
                labelWithAsterisk
            />

            <Input
                marginBottom="4px"
                label="Telefone"
                name="telefone"
                className="input"
                id="telefone"
                onChange={e => validateTelefone(e)}
                value={telefoneId}
                erro={erroTelefone}
                messageErro={erroTelefoneMsg}
                inputmode="numeric"
                labelWithAsterisk
            // maxLength={13}
            />
            <Input
                marginBottom="4px"
                label="Celular"
                name="celular"
                className="input"
                id="celular"
                value={celularId}
                onChange={e => validateCelular(e)}
                inputmode="numeric"
            />

            <Input
                marginBottom="4px"
                label="CEP"
                name="cep"
                className="input"
                id="cep"
                onChange={e => validateCep(e)}
                onBlur={fetchCep}
                erro={erroCep}
                messageErro={erroCepMsg}
                value={cepId}
                disabled={loadingCep}
                loading={loadingCep}
                inputmode="numeric"
                labelWithAsterisk
            />

            <Input
                marginBottom="4px"
                label="Logradouro"
                value={logradouroId}
                name="logradouro"
                className="input"
                id="logradouro"
                onChange={e => validateLogradouro(e)}
                erro={erroLogradouro}
                messageErro={erroLogradouroMsg}
                disabled={loadingCep && !enderecoManual}
                loading={loadingCep && !enderecoManual}
                labelWithAsterisk
            />

            <Input
                marginBottom="4px"
                label="Bairro"
                value={bairroId}
                name="bairro"
                className="input"
                id="bairro"
                onChange={e => validateBairro(e)}
                erro={erroBairro}
                messageErro={erroBairroMsg}
                disabled={loadingCep && !enderecoManual}
                loading={loadingCep && !enderecoManual}
                labelWithAsterisk
            />

            <Input
                marginBottom="4px"
                label="Número"
                name="numero"
                className="input"
                id="numero"
                onChange={e => validateNumero(e)}
                erro={erroNumero}
                messageErro={erroNumeroMsg}
                value={numeroId}
                labelWithAsterisk
            />

            <Input
                marginBottom="4px"
                label="Complemento"
                name="complemento"
                className="input"
                id="complemento"
                onChange={e => validateComplemento(e)}
                value={complementoId}

            />
            <Input
                marginBottom="4px"
                value={cidadeId}
                label="Cidade"
                name="cidade"
                className="input"
                id="cidade"
                onChange={e => validateCidade(e)}
                erro={erroCidade}
                messageErro={erroCidadeMsg}
                disabled={cepFound || (loadingCep && !enderecoManual)}
                loading={loadingCep && !enderecoManual}
                labelWithAsterisk
            />

            <Select
                marginBottom="4px"
                label="Estado"
                name="estado"
                className="select"
                id="estado_id"
                onChange={(e) => e.value ? validateEstado(e.value) : validateEstado(e)}
                options={estados}
                value={estadoId ? estadoId.value ? estadoId.value : estadoId : ''}
                disabled={disabledEstado || (loadingCep && !enderecoManual)}
                loading={loadingCep && !enderecoManual}
                estado={true}
                erro={erroEstado}
                messageErro={erroEstadoMsg}
                labelWithAsterisk
            />

            <div
                className="button-finish"
                style={{
                    width: '100%',
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'space-evenly',
                    alignItems: 'center',
                    marginTop: '40px',
                    marginBottom: props.isModal ? '0px' : '40px',
                }}
            >
                <Button
                    width='100%'
                    height='50px'
                    value='CADASTRAR'
                    outline={false}
                    disabled={false}
                    onClick={() => saveProducer()}
                    loading={loading}
                />
            </div>
        </Form>
    </>)
}

export default AddProdutor;
